// Unidades en Servicio — autos con días en bloqueo de servicio dentro del
// periodo. Muestra el total de días y cuántos bloqueos.
import supabase from "../../../supabase-client";

const fmtDays = (v) => Math.round(Number(v) || 0);

export const unitsInServiceReport = {
  id: "units-in-service",
  title: "Unidades en Servicio",
  description: "Autos con días en bloqueo de servicio dentro del periodo.",
  category: "Operaciones",
  filters: [
    { type: "daterange", fromKey: "from", toKey: "to", label: "Periodo", required: true },
  ],
  summary: [
    { type: "count", label: "Autos en Servicio" },
    { type: "sum", label: "Días en Servicio", valueKey: "service_days", valueFormat: fmtDays },
  ],
  columns: [
    { key: "plate", label: "Placa" },
    { key: "model", label: "Modelo", width: 220, truncate: true },
    { key: "branch", label: "Sucursal" },
    { key: "service_days", label: "Días", format: fmtDays, exportType: "integer" },
    { key: "service_blocks", label: "Bloqueos", exportType: "integer" },
  ],
  async fetch({ from, to }) {
    if (!from || !to) throw new Error("Seleccionar periodo");
    const { data, error } = await supabase.rpc("report_units_in_service", {
      p_from: from, p_to: to,
    });
    if (error) throw error;
    return data || [];
  },
};
